module.exports = __webpack_public_path__ + "static/img/bot2.5d7c1d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bot2.png
// module id = 5AS+
// module chunks = 31